/* eslint-disable react/no-danger */
import { Link } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import { BlogLiveType } from "types/BlogPostType";
import TextLink from "hardcover-ui/components/TextLink";
import Text from "hardcover-ui/components/Text";
import WatchYouTube from "./live/WatchYouTube";
import ListenPodcast from "./live/ListenPodcast";

export function BlogLive({ post }: { post?: BlogLiveType }) {
  return (
    <Container variant="layout">
      <div className="relative px-2 sm:px-6 lg:px-8 mt-12">
        <Text variant="secondary" size="sm" as="p">
          <TextLink variant="secondary" href="/live" size="sm">
            &larr; All Episodes
          </TextLink>
        </Text>
        <div className="mt-4 text-lg max-w-prose mx-auto flex flex-col items-start">
          <Heading size="xl" className="text-center w-full">
            {post.title}
          </Heading>
          {post.participants.length > 0 ? (
            <div className="w-full mt-4 flex flex-row space-x-2 justify-center">
              {post.participants.map((participant) => (
                <img
                  key={participant.name}
                  src={participant.avatar.url}
                  width={40}
                  height={40}
                  className="h-10 w-10 rounded-full"
                  alt={`Avatar for ${participant.name}`}
                  loading="lazy"
                  data-tooltip-content={participant.name}
                  data-tooltip-id="tooltip"
                />
              ))}
            </div>
          ) : (
            false
          )}
          <div className="mt-4 mb-8 flex items-start mx-auto w-full justify-center">
            <div className="ml-3">
              <div className="flex space-x-1 text-sm text-gray-600 dark:text-gray-400">
                <time dateTime={post.dateIso}>
                  {post.dateReadableFull}
                </time>
                <span aria-hidden="true">&middot;</span>
                <span>{post.readingTime} min read</span>
              </div>
            </div>
          </div>
          {post.youtubeId ? (
            <div className="w-full">
              <iframe
                className="aspect-video w-full"
                src={`https://www.youtube.com/embed/${post.youtubeId}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          ) : (
            false
          )}

          <div className="flex flex-row my-4 justify-center txt-center">
            {post.youtubeId ? (
              <WatchYouTube youtubeId={post.youtubeId} />
            ) : (
              false
            )}
            {post.podcastUrl ? (
              <ListenPodcast podcastUrl={post.podcastUrl} />
            ) : (
              false
            )}
          </div>

          <div
            className="mt-4 prose dark:prose-invert prose-lg lg:prose-xl mx-auto"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
        </div>
        <p className="text-gray-300 text-lg max-w-prose mx-auto mt-8">
          <Link
            href="/live"
            className="px-2 py-1 text-indigo-600 dark:text-indigo-300 hover:text-indigo-100 hover:no-underline hover:rounded hover:bg-indigo-500"
          >
            &larr; More from Hardcover Live
          </Link>
        </p>
      </div>
    </Container>
  );
}
